export default __webpack_public_path__ + "static/media/640_store03-it-mobile.5b542306.png";